<h1>Voorraad aanmaken</h1>
<h2>{{ data.plantName }}</h2>
<mat-dialog-content class="dialog-content-alignment">
  <mat-form-field *ngIf="data.hasReservedStock">
    <input
      matInput
      type="number"
      placeholder="Gereserveerde hoeveelheid"
      [(ngModel)]="data.totalReservedAmount"
      [disabled]="true"
    />
  </mat-form-field>

  <mat-form-field *ngIf="data.hasReservedStock">
    <input
      matInput
      type="number"
      placeholder="Ingangsmateriaal gebruikt"
      [ngModel]="inputMaterialAmount"
      (ngModelChange)="onInputMaterialUsedChanged($event)"
      [attr.max]="data.totalReservedAmount"
    />
  </mat-form-field>

  <mat-form-field *ngIf="data.hasReservedStock">
    <input
      matInput
      type="number"
      placeholder="Ingangsmateriaal weggegooid"
      [value]="inputMaterialAmountTrashed"
      (input)="onTrashedInput($event)"
    />
  </mat-form-field>

  <mat-form-field>
    <input
      matInput
      type="number"
      placeholder="Originele hoeveelheid"
      [ngModel]="originalAmount"
      (ngModelChange)="onOriginalAmountChanged($event)"
    />
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="Bed nummer" [(ngModel)]="location">
  </mat-form-field>
  <mat-form-field>
    <input matInput placeholder="Opmerking" [(ngModel)]="remarks">
  </mat-form-field>

  <app-unitsize-autocomplete-field [preFilledUnitSizeId]="data.materialUnitSizeId"
                                   (unitSizeChange)="setMaterialUnitSize($event)"
                                   [label]="'Maat ingangsmateriaal'"
  >
  </app-unitsize-autocomplete-field>
  <app-unitsize-autocomplete-field [preFilledUnitSizeId]="data.targetUnitSizeId"
                                   (unitSizeChange)="setTargetUnitSize($event)"
                                   [label]="'Doel maat'">
  </app-unitsize-autocomplete-field>
  <mat-form-field>
    <mat-label>Productie datum</mat-label>
    <div class="date-picker-production-date">
      <input matInput [matDatepicker]="picker" [(ngModel)]="productionDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </mat-form-field>
  <app-enum-combobox
    [label]="'Type stek'"
    [enumType]="PlugType"
    [preFilledValue]="selectedPlugType"
    (valueChange)="onPlugTypeChange($event)">
  </app-enum-combobox>
  <mat-dialog-actions class="">
    <button mat-raised-button (click)="cancel()">
      <i class="material-icons" aria-label="Annuleren">backspace</i>
      Annuleren
    </button>
    <button [disabled]="isDisabled()" mat-raised-button color="primary" (click)="onSubmitClick()">
      Toevoegen
      <mat-icon>archive</mat-icon>
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
